import { Card, CardContent } from "./ui/card";
import { X } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { useBanner } from "@/hooks/use-banner";
import WalkthroughIcon from "@/icons/WalkthroughIcon";

export const WalkthroughBanner = () => {
  const { isVisible, handleDismiss } = useBanner({
    slug: 'walkthrough-banner',
    defaultState: {
      dismissed: false,
      dismissedAt: null,
    },
  });

  if (!isVisible) {
    return null;
  }

  return (
    <Card className="cy:relative cy:py-4 cy:mb-6 cy:border-[#D4E3FF] cy:bg-[#EBF2FF] cy:shadow-sm cy:rounded-lg">
      <CardContent >
        {/* Dismiss button - top right */}
        <button
          onClick={handleDismiss}
          className="cy:absolute cy:top-3 cy:right-3 cy:text-gray-400 cy:hover:text-gray-600 cy:transition-colors"
          aria-label="Dismiss banner"
        >
          <X className="cy:w-5 cy:h-5" />
        </button>

        {/* Content */}
        <div className="cy:flex cy:items-center cy:gap-6">
          {/* Icon */}
          <div className="cy:flex-shrink-0">
            <WalkthroughIcon width={130} height={130} />
          </div>

          {/* Text Content */}
          <div className="cy:flex-1">
            <h3 className="cy:text-[18px] cy:font-bold cy:text-[#1F2937] cy:pb-3 ">
              Your accessibility tool Kit — all in one place!
            </h3>
            
            <ul className="cy:space-y-2 cy:text-[14px] cy:text-black">
              <li className="cy:flex cy:items-start cy:gap-2">
                <span className="cy:flex-shrink-0 cy:w-5 cy:h-5 cy:rounded-full cy:bg-[#0251AF] cy:flex cy:items-center cy:justify-center cy:text-white cy:text-[10px] cy:font-bold cy:mt-0.5">
                  i
                </span>
                <span>
                  Scan your site for issues with{" "}
                  <Link 
                    to="/" 
                    className="cy:font-bold cy:text-black! cy:underline cy:cursor-pointer"
                  >
                    Accessibility checker
                  </Link>
                </span>
              </li>
              <li className="cy:flex cy:items-start cy:gap-2">
                <span className="cy:flex-shrink-0 cy:w-5 cy:h-5 cy:rounded-full cy:bg-[#0251AF] cy:flex cy:items-center cy:justify-center cy:text-white cy:text-[10px] cy:font-bold cy:mt-0.5">
                  i
                </span>
                <span>
                  Fix problems with built-in tools in{" "}
                  <Link 
                    to="/issue-fixes" 
                    className="cy:font-bold cy:text-black! cy:underline cy:cursor-pointer"
                  >
                    Issue fixes
                  </Link>
                </span>
              </li>
              <li className="cy:flex cy:items-start cy:gap-2">
                <span className="cy:flex-shrink-0 cy:w-5 cy:h-5 cy:rounded-full cy:bg-[#0251AF] cy:flex cy:items-center cy:justify-center cy:text-white cy:text-[10px] cy:font-bold cy:mt-0.5">
                  i
                </span>
                <span>
                  Enhance usability with the{" "}
                  <Link 
                    to="/accessibility-toolbar" 
                    className="cy:font-bold cy:text-black! cy:underline cy:cursor-pointer"
                  >
                    Toolbar
                  </Link>
                </span>
              </li>
              <li className="cy:flex cy:items-start cy:gap-2">
                <span className="cy:flex-shrink-0 cy:w-5 cy:h-5 cy:rounded-full cy:bg-[#0251AF] cy:flex cy:items-center cy:justify-center cy:text-white cy:text-[10px] cy:font-bold cy:mt-0.5">
                  i
                </span>
                <span>
                  Publish your Accessibility Statement to show your commitment using the{" "}
                  <Link 
                    to="/statement" 
                    className="cy:font-bold cy:text-black! cy:underline cy:cursor-pointer"
                  >
                    Statement generator
                  </Link>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

